import { uniqueId } from 'lodash-es';
import { GlForm, GlFormCharacterCount, GlFormGroup, GlFormRadio, GlFormRadioGroup, GlFormTextarea, GlModal } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, n__, sprintf } from '~/locale';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
const REPORT_REASON_VALUES = {
    IMMEDIATE_SECURITY_THREAT: 'IMMEDIATE_SECURITY_THREAT',
    POTENTIAL_SECURITY_THREAT: 'POTENTIAL_SECURITY_THREAT',
    EXCESSIVE_RESOURCE_USAGE: 'EXCESSIVE_RESOURCE_USAGE',
    SPAM_OR_LOW_QUALITY: 'SPAM_OR_LOW_QUALITY',
    OTHER: 'OTHER'
};
const REPORT_REASON_OPTIONS = [
    {
        value: REPORT_REASON_VALUES.IMMEDIATE_SECURITY_THREAT,
        text: s__('AICatalog|Immediate security threat'),
        help: s__('AICatalog|Contains dangerous code, exploits, or harmful actions.')
    },
    {
        value: REPORT_REASON_VALUES.POTENTIAL_SECURITY_THREAT,
        text: s__('AICatalog|Potential security threat'),
        help: s__('AICatalog|Hypothetical or low risk security flaws that could be exploited.')
    },
    {
        value: REPORT_REASON_VALUES.EXCESSIVE_RESOURCE_USAGE,
        text: s__('AICatalog|Excessive resource usage'),
        help: s__('AICatalog|Wasting compute or causing performance issues.')
    },
    {
        value: REPORT_REASON_VALUES.SPAM_OR_LOW_QUALITY,
        text: s__('AICatalog|Spam or low quality'),
        help: s__('AICatalog|Frequently failing or nuisance activity.')
    },
    {
        value: REPORT_REASON_VALUES.OTHER,
        text: s__('AICatalog|Other'),
        help: s__('AICatalog|Please describe below.')
    }
];
const MAX_BODY_LENGTH = 1000;
export default {
    name: 'AiCatalogItemReportModal',
    components: {
        GlForm,
        GlFormCharacterCount,
        GlFormGroup,
        GlFormRadio,
        GlFormRadioGroup,
        GlFormTextarea,
        GlModal
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    emits: [
        'submit'
    ],
    data () {
        return {
            reason: REPORT_REASON_OPTIONS[0].value,
            body: '',
            isDirty: false
        };
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.item.itemType);
        },
        formId () {
            return uniqueId('ai-catalog-item-report-form-');
        },
        modal () {
            return {
                actionPrimary: {
                    text: __('Submit'),
                    attributes: {
                        variant: 'confirm',
                        type: 'submit',
                        form: this.formId
                    }
                },
                actionCancel: {
                    text: __('Cancel')
                }
            };
        },
        title () {
            return sprintf(s__(`AICatalog|Report %{itemName}`), {
                itemName: this.item.name
            });
        },
        labelDescription () {
            return sprintf(s__(`AICatalog|Why are you reporting this %{itemType}?`), {
                itemType: this.itemRegistry.label
            });
        },
        isOtherSelected () {
            return this.reason === REPORT_REASON_VALUES.OTHER;
        },
        isBodyRequired () {
            return this.isOtherSelected;
        },
        isBodyOutOfLimit () {
            return this.body.length >= MAX_BODY_LENGTH;
        },
        isBodyMissing () {
            return this.isBodyRequired && this.body.trim().length === 0;
        },
        isBodyValid () {
            return !this.isDirty || !(this.isBodyOutOfLimit || this.isBodyMissing);
        },
        invalidFeedback () {
            if (this.isBodyOutOfLimit) {
                return s__('AICatalog|Additional details cannot exceed 1000 characters.');
            }
            if (this.isBodyMissing) {
                return s__('AICatalog|Additional details are required.');
            }
            return '';
        }
    },
    methods: {
        resetForm () {
            this.reason = REPORT_REASON_OPTIONS[0].value;
            this.isDirty = false;
            this.body = '';
        },
        handleSubmit () {
            this.isDirty = true;
            if (!this.isBodyValid) {
                return;
            }
            this.$refs.modal.hide();
            this.$emit('submit', {
                reason: this.reason,
                body: this.body.trim()
            });
        },
        remainingCountText (count) {
            return n__('%d character remaining.', '%d characters remaining.', count);
        },
        overLimitText (count) {
            return n__('%d character over limit.', '%d characters over limit.', count);
        }
    },
    REPORT_REASON_OPTIONS,
    COUNT_TEXT_ID: 'character-count-text',
    MAX_BODY_LENGTH
};
